import { Link, useLocation } from "wouter";
import { cn } from "../../../lib/cn";
import { FOCUS_RING } from "../../../lib/focusRing";
import { isNavActive, useNavItems } from "./useNavItems";

/**
 * Mobile bottom tab bar (below lg): the same destinations as the header pills,
 * icon + label, clear of the home indicator. The spacer before it keeps the
 * end of the page from hiding underneath.
 */
export function BottomNav() {
  const items = useNavItems();
  const [path] = useLocation();
  if (items.length === 0) return null;
  return (
    <>
      <div aria-hidden className="h-20 lg:hidden" />
      <nav
        aria-label="Main"
        className="no-print fixed inset-x-0 bottom-0 z-30 border-t border-sky-100/70 bg-white/90 pb-[env(safe-area-inset-bottom)] backdrop-blur lg:hidden"
      >
        <ul className="mx-auto flex max-w-md items-stretch justify-around px-1">
          {items.map((item) => {
            const active = isNavActive(item, path);
            const Icon = item.icon;
            return (
              <li key={item.id} className="flex-1">
                <Link
                  href={item.href}
                  data-tour={`nav-${item.id}`}
                  aria-current={active ? "page" : undefined}
                  className={cn(
                    "flex flex-col items-center gap-1 rounded-2xl px-1 py-2 text-[11px] font-semibold transition",
                    FOCUS_RING,
                    active ? "text-sky-700" : "text-neutral-600 hover:text-sky-700",
                  )}
                >
                  <span
                    className={cn(
                      "inline-flex h-8 w-12 items-center justify-center rounded-full transition",
                      active && "bg-gradient-to-br from-sky-500 to-indigo-600 text-white shadow-soft",
                    )}
                  >
                    <Icon className="h-5 w-5" aria-hidden />
                  </span>
                  {item.label}
                </Link>
              </li>
            );
          })}
        </ul>
      </nav>
    </>
  );
}
